module.exports = __webpack_public_path__ + "img/密码读卡器 (3).82578f83.jpg";